<template>
	<div>
		<SOSlotBase
			:is-search="isSearch"
			:bg-grey="!pageSetting.loading.export"
			:bg-white="pageSetting.loading.export"
			:container-name="'list-transaksi-content'"
		>
			<template v-slot:title-bar>
				<SOTitleBar
					:page-title="idcustomer === undefined ? 'Transaksi Reguler' : 'Transaksi Reguler & Deposit'"
					:type="!pageSetting.isIframe ? 'back' : undefined"
					:show-search="!pageSetting.loading.list"
					@search="search"
					@back="back"
					v-if="!isSearch && !pageSetting.loading.export"
				/>
			</template>

			<template v-slot:search-bar>
				<SOSearchBar
					v-if="isSearch && !pageSetting.loading.export"
					:context="'Transaksi'"
					:value="searchKey.key"
					:data-count="pageSetting.loading.list ? 0 : listTransaksiData.jumlah_nota"
					:waiting="pageSetting.search.waiting"
					:search-information="'Nomor nota, nama konsumen, & nama outlet'"
					@return-search-value="(v) => { searchKey.key = v }"
					@loading="loadingSearch"
					@do-search="searchTransaksi"
					@close="closeSearch"
				/>
			</template>

			<template v-slot:empty-state>
				<SOEmptyState
					v-if="listTransaksiData.jumlah_nota === 0 && !isSearch"
					:message="'Belum ada transaksi'"
				/>
				<SOEmptySearchState
					v-if="isSearch && !pageSetting.loading.list && !pageSetting.search.waiting && listTransaksiData.jumlah_nota === 0 && searchKey.key.length > 1"
					@action="() => { resetFilter(); searchKey.key = '' }"
				/>
			</template>

			<template v-slot:skeleton>
				<div class="p-x-20 p-y-16 w-limit" v-if="pageSetting.loading.list">
					<SOCardTransaksiSkeleton v-if="!isSearch"/>
					<SOLoadSearch v-if="isSearch"/>
				</div>
			</template>

			<template v-slot:content v-if="!pageSetting.loading.export">
				<SOExportProgressMinimized
					v-if="pageSetting.minimizedExport"
					:processed-data="exportProgress.processed"
					:total-data="exportProgress.total"
					:context="'transaksi reguler'"
					:tracker-actions="'transaksiModule/exportTrack'"
					@on-success="checkExport"
					@on-error="() => { pageSetting.minimizedExport = false }"
				/>
				<SOExportMultipleFile
					v-if="pageSetting.multipleExport && !pageSetting.minimizedExport"
					:export-data="exportData"
					:export-data-length="exportDataLength"
					:delete-cluster-actions="'transaksiModule/exportDeleteCluster'"
					:delete-master-actions="'transaksiModule/exportDeleteMaster'"
					@downloaded="(index) => { exportData[index].downloaded = true }"
					@done="() => { pageSetting.multipleExport = false; exportData = [] }"
				/>

				<SOCardTransaksiInfoCustomer
					class="main-page"
					:info="info"
					v-if="!isSearch && idcustomer !== undefined"
				/>
				<div class="p-x-20 p-t-16 w-limit" v-if="!pageSetting.loading.list">
					<SOHeaderList
						:title="titleHeaderListTransaksi()"
						:action-text="listTransaksiData.data.length > 0 ? '  •  <span class=\'f-semi f-14 f-c-blue\'>Lihat Ringkasan</span>' : ''"
						:show-filter="!pageSetting.isIframe"
						@action="() => { pageSetting.modal.summary = true }"
						@filter="() => { pageSetting.showFilter = true }"
					/>

					<SOCardTransaksi
						v-for="transaksi in listTransaksiData.data"
						:key="transaksi.idtransaksi"
						:transaksi="transaksi"
						:is-search="isSearch"
						:key-search="searchKey.key"
						:transaksi-global="idcustomer === undefined"
					/>

					<SOLoadMoreLoading
						v-if="listTransaksiData.jumlah_nota > 0"
						:id="'loading-list-transaksi'"
						:loading="pageSetting.loading.loadMore"
					/>
				</div>
				<SOFABExport
					v-if="idcustomer === undefined && !pageSetting.loading.list && listTransaksiData.data.length > 0"
					@export="() => { pageSetting.modal.export = true }"
				/>
				<!--<SOFABExport-->
				<!--	v-if="idcustomer === undefined && !pageSetting.loading.list && listTransaksiData.data.length > 0"-->
				<!--	@export="$toast.warning('Fitur sedang dalam perbaikan')"-->
				<!--/>-->
			</template>

			<template v-slot:filter>
				<SOFilter
					v-if="pageSetting.showFilter"
					:filter-transaksi-konsumen="pageSetting.showFilter"
					:sorting="sorting"
					@back="() => { pageSetting.showFilter = false }"
					@do-filter="doFilter"
					@reset-filter="resetFilter"
				/>
			</template>

			<template v-slot:modal>
				<TransaksiModalRingkasan
					v-if="pageSetting.modal.summary"
					:is-loading="pageSetting.loading.ringkasan"
					@close="() => { pageSetting.modal.summary = false }"
				/>

				<SOModalExport
					v-if="pageSetting.modal.export"
					:is-running="pageSetting.minimizedExport"
					:context="'Transaksi Reguler'"
					:total-data="listTransaksiData.jumlah_nota + ' Nota'"
					:use-option="true"
					:options="exportOptions.data"
					:selected-option="exportOptions.selected"
					:export-data-exist="exportData.length > 0 ? exportData.filter(v => v.downloaded === false).length : 0"
					@export-option-selected="(selected) => { exportOptions.selected = selected }"
					@close="() => { pageSetting.modal.export = false }"
					@do-export="doExport"
				/>
			</template>

			<template v-slot:export-import>
				<SOExportProgress
					v-if="pageSetting.loading.export"
					:context="'transaksi reguler'"
					:tracker-actions="'transaksiModule/exportTrack'"
					@on-success="checkExport"
					@on-error="() => { pageSetting.loading.export = false }"
					@minimized-export="minimizedExport"
				/>
			</template>
		</SOSlotBase>
	</div>
</template>

<script>
import {mapGetters} from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase.vue";

import SOTitleBar from "@/so-components/global/ui/SOTitleBar.vue";
import SOExportMultipleFile from "@/so-components/global/ui/SOExportMultipleFile";
import SOSearchBar from "@/so-components/global/ui/SOSearchBar";
import SOCardTransaksiInfoCustomer from "@/so-components/modules/transaksi/reguler/SOCardTransaksiInfoCustomer";

import SOCardTransaksiSkeleton from "@/so-components/modules/transaksi/reguler/SOCardTransaksiSkeleton";
import SOLoadSearch from "@/so-components/global/ui/SOLoadSearch";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOEmptySearchState from "@/so-components/global/ui/SOEmptySearchState";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList.vue";
import SOCardTransaksi from "@/so-components/modules/transaksi/reguler/SOCardTransaksi";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOFABExport from "@/so-components/global/ui/SOFABExport";

import SOFilter from "@/so-components/global/filter/base/SOFilter";

import TransaksiModalRingkasan from "./modal/TransaksiModalRingkasan";
import SOModalExport from "@/so-components/global/modal/SOModalExport";

import SOExportProgress from "@/so-components/global/ui/SOExportProgress";
import SOExportProgressMinimized from "@/so-components/global/ui/SOExportProgressMinimized";

export default {
	name: "Transaksi",
	components: {
		SOSlotBase,

		SOTitleBar,
		SOExportMultipleFile,
		SOSearchBar,
		SOCardTransaksiInfoCustomer,

		SOCardTransaksiSkeleton,
		SOLoadSearch,
		SOEmptyState,
		SOEmptySearchState,
		SOHeaderList,
		SOCardTransaksi,
		SOLoadMoreLoading,
		SOFABExport,

		SOFilter,

		TransaksiModalRingkasan,
		SOModalExport,

		SOExportProgress,
		SOExportProgressMinimized,
	},
	computed: {
		...mapGetters("transaksiModule", {
			listTransaksiData: "getListTransaksiKonsumen",
			info: "getInfoTransaksiKonsumen",
			pagination: "getPagination",
			searchKey: "getSearch",
			isSearch: "getIsSearch",
			scrollPosition: "getScrollPosition",
		}),
		...mapGetters("filterGlobalModule", {
			filter: "getFilter",
			filterItem: "getFilterItem",
		}),
	},
	data() {
		return {
			idcustomer: "",
			sorting: [
				{
					label: "Transaksi terbaru",
					name: "sorting",
					value: JSON.stringify({
						sortBy: "transaksi",
						orderBy: "DESC",
					}),
					id: "sorting-1"
				},
				{
					label: "Transaksi terlama",
					name: "sorting",
					value: JSON.stringify({
						sortBy: "transaksi",
						orderBy: "ASC",
					}),
					id: "sorting-2"
				},
				{
					label: "Nominal tertinggi",
					name: "sorting",
					value: JSON.stringify({
						sortBy: "nominal",
						orderBy: "DESC",
					}),
					id: "sorting-3"
				},
				{
					label: "Nominal terendah",
					name: "sorting",
					value: JSON.stringify({
						sortBy: "nominal",
						orderBy: "ASC",
					}),
					id: "sorting-4"
				},
				// {
				// 	label: "Abjad A-Z",
				// 	name: "sorting",
				// 	value: JSON.stringify({
				// 		sortBy: "abjad",
				// 		orderBy: "ASC",
				// 	}),
				// 	id: "sorting-5"
				// },
				// {
				// 	label: "Abjad Z-A",
				// 	name: "sorting",
				// 	value: JSON.stringify({
				// 		sortBy: "abjad",
				// 		orderBy: "DESC",
				// 	}),
				// 	id: "sorting-6"
				// },
			],
			exportOptions: {
				data: [
					{
						id: "transaksi_reguler_export",
						text: "Data Transaksi",
					},
					{
						id: "rak_transaksi_export",
						text: "Nomor Rak",
					},
					{
						id: "pengerjaan_transaksi_export",
						text: "Riwayat Pengerjaan"
					},
					{
						id: "pembayaran_transaksi_export",
						text: "Riwayat Pembayaran",
					}
				],
				selected: "transaksi_reguler_export",
			},
			pageSetting: {
				showFilter: false,

				loading: {
					list: true,
					loadMore: false,
					export: false,
					ringkasan: false,
				},
				minimizedExport: false,
				multipleExport: false,
				modal: {
					summary: false,
					export: false,
				},
				search: {
					waiting: false,
				},
				error: {
					list: false,
				}
			},
			exportProgress: {
				processed: 0,
				total: 0,
			},
			exportData: [],
			exportDataLength: 0,
			isIframe: false,
		}
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			let query = vm.$route.query
			if (from.path.split("/")[1] !== "transaksi" && from.path.split("/")[2] !== "reguler") {
				if (from.path.split("/")[1] === "pembatalan_transaksi_reguler") {
					vm.setScrollPosition()
					return
				}
				vm.initTransaksi(query)
			} else if (from.path.split("/")[1] === "transaksi" && from.path.split("/")[2] !== "reguler") {
				vm.initTransaksi(query)
			} else if (from.path.split("/")[1] === "konsumen") {
				vm.initTransaksi(query)
			} else {
				if (vm.listTransaksiData.data === undefined) {
					vm.initTransaksi(query)
					return
				}
				vm.setScrollPosition()
			}
		})
	},
	async mounted() {
		this.idcustomer = this.$route.params.idcustomer

		// await this.setDefaultFilter()
		// await this.getInfoTransaksi()
		// await this.listTransaksi()
		await this.scroll()
		await this.checkExport()
		this.smartTrackingView("transaksi_reguler",);

	},
	methods: {
		back() {
			// this.$router.push("/konsumen/detail/" + this.idcustomer)
			if (this.idcustomer === undefined || this.idcustomer === '') {
				this.$router.push({name: "TransaksiDanPenghapusan"});
			} else {
				this.$router.back()
			}
		},

		async initTransaksi(query) {
			this.pageSetting.isIframe = query.iframe == 1
			await this.flushData()

			await this.setDefaultFilter(query)
			this.getInfoTransaksi()
			await this.listTransaksi()
		},
		async listTransaksi() {
			if (!this.pageSetting.loading.list) {
				this.pageSetting.loading.loadMore = true
			}
			if (this.listTransaksiData.data !== undefined && this.listTransaksiData.data.lenght === 0) {
				this.pageSetting.search.waiting = true
			}
			const res = await this.$store.dispatch("transaksiModule/fetchListTransaksiKonsumen", this.idcustomer)
			this.pageSetting.loading.list = false
			this.pageSetting.loading.loadMore = false
			this.pageSetting.search.waiting = false
			this.$store.commit("helper/setScrollCalled", false)
			if (res.success) {
				this.pageSetting.error.list = false
				await this.$store.commit("transaksiModule/setNextPagination", {data: this.listTransaksiData.data})
			} else {
				this.pageSetting.error.list = true
				setTimeout(() => {
					this.pageSetting.error.list = false
				}, 10000)
				this.$toast.error(res.err)
			}
		},
		async getInfoTransaksi() {
			this.pageSetting.loading.ringkasan = true
			const res = await this.$store.dispatch("transaksiModule/fetchInfoTransaksiKonsumen", this.idcustomer)
			this.pageSetting.loading.ringkasan = false
			if (!res.success) {
				this.$toast.error(res.err)
			}
		},
		titleHeaderListTransaksi() {
			let strTotal = this.isSearch ? '' : 'Total '
			if (this.isSearch && this.searchKey.key.length < 2) {
				return ''
			} else if (this.isSearch && this.searchKey.key.length >= 2) {
				if (this.listTransaksiData.data !== undefined && this.listTransaksiData.data.length > 0) {
					return strTotal + this.formatRupiah(this.listTransaksiData.jumlah_nota) + ' Nota'
				}
			} else {
				if (this.listTransaksiData.data !== undefined) {
					return strTotal + this.formatRupiah(this.listTransaksiData.jumlah_nota) + ' Nota'
				} else {
					return strTotal + '0 Nota'
				}
			}
		},

		scroll() {
			window.onscroll = async () => {
				if (this.pageSetting.error.list) {
					return
				}
				let payload = {
					idLoadMore: "loading-list-transaksi",
					container: "list-transaksi-content",
					pagination: this.pagination,
					callback: this.listTransaksi,
				}
				await this.$store.dispatch("helper/scroll", payload)
			}
		},
		setScrollPosition() {
			this.pageSetting.loading.list = false
			setTimeout(() => {
				window.scrollTo(0, this.scrollPosition)
			}, 5)
		},

		// filter
		async setDefaultFilter(query) {
			// let query = this.$route.query
			await this.$store.commit("filterGlobalModule/resetFilterItem")
			if (Object.keys(query).length > 0) {
				let filterItem = this.filterItem
				if (query.filter_by) filterItem.periode.filterBy = query.filter_by
				if (query.filter_kolom) filterItem.filterKolomTransaksi = query.filter_kolom
				if (query.tanggal_awal) filterItem.periode.startDate = query.tanggal_awal
				if (query.tanggal_akhir) filterItem.periode.endDate = query.tanggal_akhir
				if (query.bulan) filterItem.periode.month = query.bulan
				if (query.tahun) filterItem.periode.year = query.tahun
				if (query.jenis_transaksi_array) filterItem.jenisTransaksi = (Array.isArray(query.jenis_transaksi_array)) ? query.jenis_transaksi_array : [query.jenis_transaksi_array]
				if (query.jenis_pembayaran) filterItem.jenisPembayaran = (Array.isArray(query.jenis_pembayaran)) ? query.jenis_pembayaran : [query.jenis_pembayaran]
				if (query.idakundebit) filterItem.jenisPembayaranAkunDebit = query.idakundebit
				if (query.outlet_array) filterItem.outlet = (Array.isArray(query.outlet_array)) ? query.outlet_array : [query.outlet_array]
				if (query.status_bayar_array) filterItem.statusPembayaran = (Array.isArray(query.status_bayar_array)) ? query.status_bayar_array : [query.status_bayar_array]
				if (query.tipe_pembayaran) filterItem.tipePembayaran = (Array.isArray(query.tipe_pembayaran)) ? query.tipe_pembayaran : [query.tipe_pembayaran]
				if (query.status_transaksi_array) filterItem.statusTransaksi = (Array.isArray(query.status_transaksi_array)) ? query.status_transaksi_array : [query.status_transaksi_array]
				if (query.tahapan_pengerjaan_array) filterItem.tahapan = (Array.isArray(query.tahapan_pengerjaan_array)) ? query.tahapan_pengerjaan_array : [query.tahapan_pengerjaan_array]
				if (query.karyawan) filterItem.karyawan = query.karyawan
				if (query.idmesin) filterItem.mesinSnap = query.idmesin
				if (query.layanan) filterItem.layananOwner = (Array.isArray(query.layanan)) ? query.layanan : [query.layanan]
				if (query.idpromo) filterItem.idpromo = query.idpromo 
				if (this.pageSetting.isIframe && !query.filter_by) {
					filterItem.periode.filterBy = "periode"
					const now = this.$moment().format('YYYY-MM-DD')
					filterItem.periode.startDate = now
					filterItem.periode.endDate = now
				}

				await this.$store.commit("filterGlobalModule/setFilterItem", filterItem)

				if (query.key) {
					await this.$store.commit("transaksiModule/setSearch", query.key)
					await this.$store.commit("transaksiModule/setIsSearch", true)
				}

				let temp = this.filter
				temp.sortBy = query.sort_by
				temp.orderBy = query.order_by
				await this.$store.commit("filterGlobalModule/setFilter", temp)
			} else {
				await this.resetFilter()
			}

			await this.$store.commit("transaksiModule/resetPagination")
		},
		async resetFilter() {
			let temp = this.filter
			temp.sortBy = "transaksi"
			temp.orderBy = "DESC"
			await this.$store.commit("filterGlobalModule/resetFilterItem")
			await this.$store.commit("filterGlobalModule/setFilter", temp)

			// urgent db down
			let filterItem = this.filterItem
			filterItem.periode.filterBy = "bulan"
			filterItem.periode.month = this.$moment().format("YYYY-MM")
			await this.$store.commit("filterGlobalModule/setFilterItem", filterItem)
		},
		async doFilter() {
			this.pageSetting.showFilter = false
			if (this.isSearch && this.searchKey.key.length < 2) {
				return
			}
			this.pageSetting.loading.list = true
			this.pageSetting.search.waiting = true
			this.getInfoTransaksi()
			await this.$store.commit("transaksiModule/resetPagination")
			await this.$store.commit("transaksiModule/resetListTransaksiKonsumen")
			await this.listTransaksi()
		},

		// search
		async searchTransaksi(search) {
			await this.$store.commit("transaksiModule/resetSearch")
			await this.$store.commit("transaksiModule/resetListTransaksiKonsumen")
			await this.$store.commit("transaksiModule/resetInfoTransaksiKonsumen")
			await this.$store.commit("transaksiModule/resetPagination")

			await this.$store.commit("transaksiModule/setSearch", search)
			this.getInfoTransaksi()
			await this.listTransaksi()
			this.pageSetting.search.waiting = false
		},
		async search() {
			window.scrollTo(0, 0)
			// await this.resetFilter()
			await this.$store.commit("transaksiModule/setIsSearch", true)

			this.listTransaksiData.data = []
			this.listTransaksiData.jumlah_nota = 0
			await this.$store.commit("transaksiModule/resetSearch")
			// await this.$store.commit("transaksiModule/resetListTransaksiKonsumen")
			await this.$store.commit("transaksiModule/resetInfoTransaksiKonsumen")
			await this.$store.commit("transaksiModule/resetPagination")
		},
		async loadingSearch(loading) {
			if (!loading) {
				this.listTransaksiData.data = []
				this.listTransaksiData.jumlah_nota = 0
			}
			this.pageSetting.search.waiting = loading
			this.pageSetting.loading.list = loading
		},
		async closeSearch() {
			this.pageSetting.loading.list = true
			// await this.resetFilter()
			await this.$store.commit("transaksiModule/setIsSearch", false)

			await this.$store.commit("transaksiModule/resetSearch")
			await this.$store.commit("transaksiModule/resetListTransaksiKonsumen")
			await this.$store.commit("transaksiModule/resetInfoTransaksiKonsumen")
			await this.$store.commit("transaksiModule/resetPagination")

			this.getInfoTransaksi()
			await this.listTransaksi()
			this.pageSetting.loading.list = false
		},

		// export
		async doExport() {
			if (this.listTransaksiData.jumlah_nota > 15000) {
				this.$toast.warning("Data ekspor terlalu banyak. Gunakan filter periode untuk memperkecil jumlah data ekspor.")
				return
			}
			this.pageSetting.loading.export = true
			this.pageSetting.modal.export = false
			const res = await this.$store.dispatch("transaksiModule/export", {
				id: this.idcustomer,
				type: this.exportOptions.selected
			})
			if (!res.success) {
				this.pageSetting.loading.export = false
				this.$toast.error(res.err)
			}
		},
		minimizedExport(data) {
			this.pageSetting.loading.export = false
			this.pageSetting.minimizedExport = true
			this.exportProgress.processed = Number(data.processed)
			this.exportProgress.total = Number(data.total)
		},
		async checkExport() {
			this.pageSetting.loading.export = false
			this.pageSetting.minimizedExport = false
			this.pageSetting.multipleExport = false
			const res = await this.$store.dispatch("transaksiModule/exportTrack")
			if (!res.success) {
				return
			}
			this.exportDataLength = res.data.length
			if (res.data.info_data_export.length > 0) {
				if (res.data.status === 1) {
					this.pageSetting.multipleExport = true
					this.exportData = res.data.info_data_export
					this.exportData.forEach(v => {
						v["downloaded"] = false
					})
				} else {
					this.pageSetting.minimizedExport = true
				}
			}
		},

		async flushData() {
			await this.$store.commit("transaksiModule/resetListTransaksiKonsumen")
			await this.$store.commit("transaksiModule/resetInfoTransaksiKonsumen")
			await this.$store.commit("transaksiModule/resetPagination")
			await this.$store.commit("filterGlobalModule/resetFilter")
			await this.$store.commit("transaksiModule/resetSearch")
			await this.$store.commit("transaksiModule/setIsSearch", false)
		}
	},
	// beforeDestroy() {
	// 	this.flushData()
	// }
}
</script>